import {
  BorrowerUserDetails,
  getLoanById,
  Invitation,
  patchUpdateBorrowerContractLoan,
} from '@nemuru-eng/js-api-client';

import { ApplicationParticipant } from '@/config/types';
import { usePageContext } from '@/contexts/PageContext/PageContext';
import { useCache } from '@/hooks/requests/useCache';
import { useRequest } from '@/hooks/requests/useRequest';
import { useSetPageLoadingWhenRequesting } from '@/hooks/requests/useSetPageLoadingWhenRequesting';
import { findCurrentParticipantIdByRole } from '@/utils/findCurrentParticipantOnboardingDetails';
import { patchUpdateBorrowerContractMapper } from '@/utils/mappers/patchUpdateBorrowerContractMapper';

interface UseUpdateBorrowerDataProps {
  loanId: string;
  onboardingDetails: ApplicationParticipant['onboardingDetails'];
}
export const useUpdateBorrowerData = ({ loanId, onboardingDetails }: UseUpdateBorrowerDataProps) => {
  const { data: loan, loading: loadingGetLoanById, revalidate: revalidateLoan } = useCache(getLoanById, { loanId });
  const { request, loading: requestLoading } = useRequest();

  const {
    state: { applicationParticipant },
  } = usePageContext();

  useSetPageLoadingWhenRequesting('BORROWER_KYC', [loadingGetLoanById]);

  const areCurrentOnboardingDetailsOfTypeBorrower = onboardingDetails && 'userDetails' in onboardingDetails;

  const updateBorrowerContract = async ({
    userDetails,
    borrowerInvitation,
  }: {
    userDetails: BorrowerUserDetails;
    borrowerInvitation: Invitation;
  }) => {
    if (!loan) return;

    const currentParticipantId = findCurrentParticipantIdByRole({
      loan: loan,
      participantRole: applicationParticipant.role,
    });
    if (areCurrentOnboardingDetailsOfTypeBorrower && currentParticipantId) {
      const borrowerContractLoanData = patchUpdateBorrowerContractMapper({
        currentLoan: loan,
        userDetails,
        borrowerInvitation,
        currentParticipantId,
        currentOnboardingDetails: onboardingDetails,
      });
      if (borrowerContractLoanData) {
        await request(patchUpdateBorrowerContractLoan, { borrowerContractLoanData });
        revalidateLoan();
      }
    }
  };

  return { loan, updateBorrowerContract, requestLoading, revalidateLoan };
};
